import { TenantConfigType } from 'src/services/gql/generated';
import {
  SubscriptionCardConfigItemV1,
  createSubscriptionDefault as createSubscriptionDefaultV1,
} from './CardConfigItemV1';

export type CardConfigItem =
   SubscriptionCardConfigItemV1;

export const createDefaultCardConfigItem = (
  name: string,
  type: TenantConfigType,
): CardConfigItem => {
  switch (type) {
    case TenantConfigType.SUBSCRIPTION_CARD:
      return createSubscriptionDefaultV1(name);
    default:
      throw new Error(`Unsupported TenantConfigType: ${type}`);
  }
};

export const cardConfigItemFromJson = (
  id: string | null,
  json: string | null,
): CardConfigItem | null => {
  if (json === null) {
    return null;
  }

  const obj = JSON.parse(json);
  if (typeof obj !== 'object' || obj === null) {
    return null;
  }

  const name = obj.name;
  if (typeof name !== 'string') {
    return null;
  }

  switch (obj['version']) {
    case 'v1': {
      return {
        ...createSubscriptionDefaultV1(name),
        ...obj,
        id: obj.id ?? id,
      } as SubscriptionCardConfigItemV1;
    }
    default:
      return null;
  }
};
